var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 276,
    viewBox: "0 0 275 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275 0H0V276H275V0Z",
    fill: "#187E8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 135.99C154.506 135.99 167.938 122.559 167.938 105.99C167.938 89.4217 154.506 75.9902 137.938 75.9902C121.369 75.9902 107.938 89.4217 107.938 105.99C107.938 122.559 121.369 135.99 137.938 135.99Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 125.99C148.983 125.99 157.938 117.036 157.938 105.99C157.938 94.9445 148.983 85.9902 137.938 85.9902C126.892 85.9902 117.938 94.9445 117.938 105.99C117.938 117.036 126.892 125.99 137.938 125.99Z",
    fill: "#95E6ED",
    stroke: "#187E8A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.938 275.99H117.938C112.418 275.99 107.938 271.51 107.938 265.99V155.99C107.938 150.47 112.418 145.99 117.938 145.99H157.938C163.458 145.99 167.938 150.47 167.938 155.99V265.99C167.938 271.52 163.458 275.99 157.938 275.99Z",
    fill: "#95E6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 155.99C165.552 155.99 187.938 133.604 187.938 105.99C187.938 78.376 165.552 55.9902 137.938 55.9902C110.323 55.9902 87.9375 78.376 87.9375 105.99C87.9375 133.604 110.323 155.99 137.938 155.99Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 185.99C182.12 185.99 217.938 150.173 217.938 105.99C217.938 61.8075 182.12 25.9902 137.938 25.9902C93.7547 25.9902 57.9375 61.8075 57.9375 105.99C57.9375 150.173 93.7547 185.99 137.938 185.99Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.938 105.99H32.9375",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 210.99V0.990234",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.938 105.99L173.287 141.35",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.938 105.99C202.938 70.0902 173.838 40.9902 137.938 40.9902",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.147dbc34e476628f26fe6a0a17d49746.svg";
export { ForwardRef as ReactComponent };